import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-800 text-primary-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-1">
          <div className="mb-4 flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-movie-2-line text-xl"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">
              大象传媒
            </span>
          </div>
          <p className="text-sm leading-relaxed text-primary-100/80">
            优质影视作品推荐与影视资讯平台，致力于为影视爱好者提供丰富的电影、电视剧与综艺内容。
          </p>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-base font-semibold text-background-50">
            影视分类
          </h4>
          <ul className="flex flex-col gap-2 text-sm text-primary-100/80">
            <li>
              <Link to="/category/movie" className="transition-colors hover:text-accent-400">
                电影频道
              </Link>
            </li>
            <li>
              <Link to="/category/tv" className="transition-colors hover:text-accent-400">
                电视剧频道
              </Link>
            </li>
            <li>
              <Link to="/category/variety" className="transition-colors hover:text-accent-400">
                综艺频道
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-base font-semibold text-background-50">
            内容导航
          </h4>
          <ul className="flex flex-col gap-2 text-sm text-primary-100/80">
            <li>
              <Link to="/" className="transition-colors hover:text-accent-400">
                首页
              </Link>
            </li>
            <li>
              <Link to="/news" className="transition-colors hover:text-accent-400">
                影视资讯
              </Link>
            </li>
            <li>
              <Link to="/search" className="transition-colors hover:text-accent-400">
                搜索中心
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-base font-semibold text-background-50">
            联系我们
          </h4>
          <ul className="flex flex-col gap-3 text-sm text-primary-100/80">
            <li className="flex items-center gap-2">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-mail-line text-base"></i>
              </span>
              contact@daxiang-media.com
            </li>
            <li className="flex items-center gap-2">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-phone-line text-base"></i>
              </span>
              400-888-6688
            </li>
            <li className="flex items-center gap-2">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-map-pin-line text-base"></i>
              </span>
              北京市朝阳区文创大厦
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-700">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-primary-100/70 sm:flex-row md:px-6">
          <p>© 2026 大象传媒 版权所有 · 本站内容为前端演示数据</p>
          <p>影视推荐 · 影视资讯 · 内容聚合</p>
        </div>
      </div>
    </footer>
  );
}